"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Confirm = _interopRequireDefault(require("wix-ui-icons-common/Confirm"));

var _FormFieldErrorSmall = _interopRequireDefault(require("wix-ui-icons-common/system/FormFieldErrorSmall"));

var _StatusAlertFilled = _interopRequireDefault(require("wix-ui-icons-common/StatusAlertFilled"));

var _constants = require("../constants");

var _StepMarkerSt = require("./StepMarker.st.css");

var _excluded = ["number", "active", "type", "styleType", "hovered", "disabled", "className"];

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Stepper/components/StepMarker.js",
    _this = void 0;

var StepMarker = function StepMarker(_ref) {
  var number = _ref.number,
      active = _ref.active,
      type = _ref.type,
      styleType = _ref.styleType,
      hovered = _ref.hovered,
      disabled = _ref.disabled,
      className = _ref.className,
      otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);

  var renderCompleted = function renderCompleted() {
    return /*#__PURE__*/_react["default"].createElement(_Confirm["default"], {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 33
      }
    });
  };

  var renderNumber = function renderNumber() {
    return "".concat(number).concat(styleType === _constants.Type.Text ? '.' : '');
  };

  var renderError = function renderError() {
    return styleType === _constants.Type.Text ? /*#__PURE__*/_react["default"].createElement(_StatusAlertFilled["default"], {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 7
      }
    }) : /*#__PURE__*/_react["default"].createElement(_FormFieldErrorSmall["default"], {
      size: "12px",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 7
      }
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _StepMarkerSt.st)(_StepMarkerSt.classes.root, {
      type: type,
      styleType: styleType,
      selected: active,
      hovered: hovered
    }, className),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 5
    }
  }, type === _constants.StepType.Error ? renderError() : type === _constants.StepType.Completed ? renderCompleted() : renderNumber());
};

var _default = StepMarker;
exports["default"] = _default;
//# sourceMappingURL=StepMarker.js.map